import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { TableCellTypes } from '@nttp/enum/table-cell-type-enum';
import { SendPaymentInstructionService } from '../../../../send-payment-instruction/services/send-payment-instruction.service';
import { format } from 'date-fns';

@Component({
  selector: 'np-balance-history',
  templateUrl: './balance-history.component.html',
  styleUrls: ['./balance-history.component.scss']
})
export class BalanceHistoryComponent implements OnInit {
  public rows = [];
  public rawData = [];
  public searchForm: FormGroup;
  public currencyName: string;
  public closingBalance: any;
  public openingBalance: any;
  public currentBalance: any;
  public hasData: boolean;


  columns = [
    {
      title: 'Date',
      name: 'normalDate',
      type: TableCellTypes.Date,
      width: '120px'
    },
    {
      title: 'Beneficiary/Description',
      name: 'description',
      width: '200px'
    },
    {
      title: 'Reference',
      name: 'reference',
      width: '230px'
    },
    {
      title: 'Credit',
      name: 'credit',
      type: TableCellTypes.Number,
      class: 'text-right',
      width: '170px'
    },
    {
      title: 'Debit',
      name: 'debit',
      type: TableCellTypes.Number,
      class: 'text-right',
      width: '170px'
    },
    {
      title: 'Balance',
      name: 'balance',
      type: TableCellTypes.Number,
      class: 'text-right',
      width: '170px'
    }
  ];

  constructor(
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public currencyBalanceInfo: any,
    public dialogRef: MatDialogRef<BalanceHistoryComponent>,
    private toastr: ToastrService,
    private sendPaymentservice: SendPaymentInstructionService,

  ) { }

  ngOnInit() {
    const today = new Date();

    this.searchForm = this.fb.group({
      fromDate: [new Date(today.getFullYear(), today.getMonth(), 1)],
      toDate: [new Date()]
    });

    this.currencyName = this.currencyBalanceInfo.currencyName;
    this.currentBalance = this.currencyBalanceInfo.amount;
    this.getSearchData();
  }

  getSearchData() {
    const fromDate = this.searchForm.get('fromDate').value;
    const toDate =  this.searchForm.get('toDate').value;

    if (fromDate && toDate && fromDate > toDate) {
      this.toastr.error(`From date should not be greater than To date`);
      return;
    }

    var fromDateStr = format(fromDate, 'YYYY-MM-DD');
    var toDateStr =  format(toDate, 'YYYY-MM-DD');

    const params = {
      fromDate: fromDateStr,
      toDate: toDateStr,
      currencyId: this.currencyBalanceInfo.id
    };

    this.rows = [];
    this.hasData = false;

    this.sendPaymentservice.getBalanceBreakdownForCurrency(params).subscribe(data => {
      let dataTable = data.allBalances;

      if (dataTable && dataTable.length > 0) {
        let allBalanceInfo = dataTable[0];
        dataTable = allBalanceInfo.balanceBreakDown;
        this.openingBalance = allBalanceInfo.openingBalance;
        this.closingBalance = allBalanceInfo.closingBalance;
        this.rows = dataTable;
        this.hasData = true;
      }
    });
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
